module.exports = __webpack_public_path__ + "img/09.c1b2ad31.png";